import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={13}
        height={13}
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.94688 0.886719C3.18478 0.886719 0.9375 3.134 0.9375 5.8961C0.9375 8.65835 3.18478 10.9055 5.94688 10.9055C7.16167 10.9055 8.27683 10.4709 9.14504 9.74896L11.5231 12.127C11.6134 12.2173 11.7316 12.2625 11.85 12.2625C11.9682 12.2625 12.0866 12.2173 12.1769 12.127C12.3576 11.9465 12.3576 11.6536 12.1769 11.4731L9.79897 9.09519C10.5213 8.22685 10.9563 7.11132 10.9563 5.8961C10.9563 3.134 8.70914 0.886719 5.94688 0.886719ZM5.94578 9.98044C3.69356 9.98044 1.86121 8.14809 1.86121 5.89587C1.86121 3.64366 3.69356 1.81128 5.94578 1.81128C8.19799 1.81128 10.0303 3.64364 10.0303 5.89585C10.0303 8.14807 8.19799 9.98044 5.94578 9.98044Z"
            fill="#64676D"
        />
    </svg>
);
export default SVGComponent;
